const HeaderSize = {
  topPad: 20,
  BottomPad: 91
};

export { HeaderSize };
